import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../shared/locales/no.json';
import SubmitButton from '../../components/form/formComponents/SubmitButton';
import Input from '../../components/form/formComponents/Input';
import Form from '../../components/form/Form';
import FadeIn from '../FadeIn';

export default class CancelableTextInput extends React.Component {
    static propTypes = {
        onSave: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired,
        text: PropTypes.string.isRequired,
        mode: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
    };

    render() {
        const { onSave, onCancel, mode, text, id, ...props } = this.props;
        return (
            <FadeIn>
                <Form onValidSubmit={onSave}>
                    <Input
                        classes="input input--text u-mb0"
                        id={`${id}_${props.name}`}
                        value={text}
                        {...props}
                    />
                    <div className="u-mv16">
                        <SubmitButton
                            className="button--cta"
                            mode={mode}
                            value={i18n['Save button']}
                        />

                        <button className="button u-ml8" onClick={onCancel}>
                            {i18n['Cancel button']}
                        </button>
                    </div>
                </Form>
            </FadeIn>
        );
    }
}
